import React from 'react';
import { brandGradients } from '../theme/palette';

const Team = () => {
  const leadership = [
    {
      name: 'L. Raghuveer Reddy',
      position: 'Founder & Director',
      description: 'Visionary leader who established RLDS Pvt Ltd in 2019, bringing extensive experience in detective services and client relationship management.',
      avatar: '/images/team/l-raghuveer-reddy.jpeg',
      specialties: ['Strategic Leadership', 'Business Development', 'Client Relations'],
      color: 'from-blue-600 to-blue-700'
    },
    {
      name: 'Apsar Basha',
      position: 'Regional Manager',
      description: 'Experienced regional operations manager overseeing service delivery and quality assurance across multiple states.',
      avatar: '/images/team/apsar-basha.jpeg',
      specialties: ['Operations Management', 'Quality Control', 'Team Leadership'],
      color: 'from-green-600 to-green-700'
    },
    {
      name: 'B Krishna Kishore',
      position: 'Legal Head',
      description: 'Legal expert ensuring all verification processes comply with regulatory requirements and maintaining legal standards.',
      avatar: '/images/team/b-krishna-kishore.jpeg',
      specialties: ['Legal Compliance', 'Documentation', 'Risk Assessment'],
      color: 'from-purple-600 to-purple-700'
    },
    {
      name: 'B Venkata Krishna',
      position: 'Legal Committee',
      description: 'Supervises legal monitoring activities and ensures adherence to legal protocols in all verification processes.',
      avatar: '/images/team/b-venkata-krishna.jpeg',
      specialties: ['Legal Monitoring', 'Process Supervision', 'Compliance Management'],
      color: 'from-indigo-600 to-indigo-700'
    }
  ];

  const regionalTeam = [
    // {
    //   name: 'Durga Rao',
    //   position: 'Area Manager Operations - AP',
    //   location: 'Andhra Pradesh',
    //   color: 'from-red-500 to-red-600',
    //   avatar: '/images/team/durga-rao.jpg',
    //   specialties: ['Operations', 'Client Delivery', 'AP Region']
    // },
    // {
    //   name: 'Chandra Mohan',
    //   position: 'Area Manager - Rayalasima',
    //   location: 'Rayalasima Region',
    //   color: 'from-orange-500 to-orange-600',
    //   avatar: '/images/team/chandra-mohan.jpg',
    //   specialties: ['Rayalaseema Ops', 'Vendor Mgmt', 'Turnaround Time']
    // },
    {
      name: 'Prathusha Rajshekar',
      position: 'Regional Manager - Hyderabad',
      location: 'Telangana',
      color: 'from-pink-500 to-pink-600',
      avatar: '/images/team/prathusha-rajshekar.jpeg',
      specialties: ['Hyderabad Region', 'Quality Control', 'Client Success']
    },
    {
      name: 'P Naveen Kumar',
      position: 'Regional Manager - Due Diligence',
      location: 'Karnataka',
      color: 'from-purple-500 to-purple-600',
      avatar: '/images/team/p-naveen-kumar.jpeg',
      specialties: ['Bengaluru Ops', 'Field Audits', 'Reporting']
    }
    
    // {
    //   name: 'A Ravi Kiran',
    //   position: 'Regional Head - Public Relations',
    //   location: 'Regional Operations',
    //   color: 'from-blue-500 to-blue-600',
    //   avatar: '/images/team/a-ravi-kiran.jpeg',
    //   specialties: ['Regional Audit', 'Process Improvement', 'Training']
    // }
    // {
    //   name: 'Siva Kumar',
    //   position: 'Auditing & Account Head',
    //   location: 'Head Office',
    //   color: 'from-yellow-500 to-yellow-600',
    //   avatar: '/images/team/siva-kumar.jpg',
    //   specialties: ['Audit', 'Accounts', 'Compliance']
    // }
  ];

  return (
    <section id="team" className="py-20 lg:py-16 bg-white">
  <div className="container">
        {/* Section Header */}
        <div className="text-center mb-10 animate-on-scroll">
          <span className="text-xl font-bold" style={{ color: '#ff70a6' }}>
             Our Team
          </span>
          {/* <span className="text-[#00a4f4] text-lg font-bold"> */}
           
          {/* </span> */}
          <h2 className="text-4xl lg:text-6xl font-black text-gray-800 mt-4 mb-8 leading-tight">
            Meet Our Expert
            <span className="block text-blue-600">Leadership Team</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Our experienced leadership team combines expertise in law, operations, auditing, and regional management 
            to deliver exceptional verification services across South India.
          </p>
        </div>

        {/* Leadership Team */}
        <div className="mb-10">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8 animate-on-scroll">Executive Leadership</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {leadership.map((leader, index) => (
              <div 
                key={index} 
                className="group bg-white rounded-3xl overflow-hidden shadow-1xl hover:shadow-1xl transition-all duration-500 animate-on-scroll border border-gray-100 hover:border-blue-200"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative overflow-hidden">
                  <img 
                    src={leader.avatar} 
                    alt={leader.name}
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/team/placeholder.svg'; }}
                    className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  {/* Position Badge */}
                  <div className="absolute top-4 left-4 right-4">
                    <div className={`bg-gradient-to-r ${leader.color} text-white px-4 py-2 rounded-full text-sm font-semibold text-center shadow-lg`}>
                      {leader.position}
                    </div>
                  </div>

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                    <div className="p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 w-full">
                      <div className="flex flex-wrap gap-2">
                        {leader.specialties.map((specialty, idx) => (
                          <span key={idx} className="px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium">
                            {specialty}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                    {leader.name}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {leader.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Regional Team */}
        <div className="animate-on-scroll">
          <h3 className="text-3xl font-bold text-gray-800 text-center mb-8">Regional & Departmental Heads</h3>
          <div className="grid md:grid-cols-2 gap-8 lg:grid-cols-none lg:flex lg:flex-wrap lg:justify-center lg:gap-8">
            {regionalTeam.map((member, index) => (
              <div
                key={index}
                className="group bg-white rounded-3xl overflow-hidden shadow-1xl hover:shadow-1xl transition-all duration-500 animate-on-scroll border border-gray-100 hover:border-blue-200 lg:basis-1/4"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/images/team/placeholder.svg'; }}
                    className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  {/* Position Badge */}
                  <div className="absolute top-4 left-4 right-4">
                    <div className={`bg-gradient-to-r ${member.color} text-white px-4 py-2 rounded-full text-sm font-semibold text-center shadow-lg`}>
                      {member.position}
                    </div>
                  </div>

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                    <div className="p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 w-full">
                      <div className="flex flex-wrap gap-2">
                        {member.specialties?.map((specialty, idx) => (
                          <span key={idx} className="px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium">
                            {specialty}
                          </span>
                        ))}
                        <span className="px-2 py-1 bg-white/20 backdrop-blur-sm rounded-full text-xs font-medium">
                          <i className="fas fa-map-marker-alt mr-1"></i>{member.location}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <h4 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors duration-300">
                    {member.name}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {member.position} — {member.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Team Stats */}
        <div className="mt-20 animate-on-scroll">
          <div className="rounded-3xl p-12 text-white" style={{ background: brandGradients.panel }}>
            <div className="text-center mb-8">
              <h3 className="text-3xl lg:text-4xl font-bold mb-4">
                Professional Excellence Across South India
              </h3>
              <p className="text-xl opacity-90 max-w-3xl mx-auto">
                Our diverse team of experts brings together decades of combined experience in legal, 
                auditing, and operational excellence to serve our clients professionally.
              </p>
            </div>

            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">100+</div>
                <div className="text-sm opacity-80">Team Members</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">4</div>
                <div className="text-sm opacity-80">States Covered</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">10+</div>
                <div className="text-sm opacity-80">Years Experience</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">100%</div>
                <div className="text-sm opacity-80">Professional Service</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;